export default {
  id: '4464316',
  name: '智慧消防云平台',
  font_family: 'iconfont',
  css_prefix_text: 'icon-',
  description: '',
  glyphs: [
    {
      icon_id: '37930694',
      name: '人工智能',
      font_class: 'rengongzhineng2',
      unicode: 'e716',
      unicode_decimal: 59158,
    },
    {
      icon_id: '42012390',
      name: 'CSMART-AI通道监控-AI摄像头',
      font_class: 'CSMART-AItongdaojiankong-AIshexiangtou',
      unicode: 'e6fd',
      unicode_decimal: 59133,
    },
    {
      icon_id: '25299720',
      name: '44声光喇叭',
      font_class: 'a-44shengguanglaba',
      unicode: 'e6f8',
      unicode_decimal: 59128,
    },
    {
      icon_id: '36519671',
      name: '水压表',
      font_class: 'shuiyabiao',
      unicode: 'e6f6',
      unicode_decimal: 59126,
    },
    {
      icon_id: '10685741',
      name: '消防-主机',
      font_class: 'xiaofang-zhuji',
      unicode: 'e6f5',
      unicode_decimal: 59125,
    },
    {
      icon_id: '10088116',
      name: '未完成',
      font_class: 'weiwancheng',
      unicode: 'e6f3',
      unicode_decimal: 59123,
    },
    {
      icon_id: '14445938',
      name: '组织架构',
      font_class: 'zuzhijiagou',
      unicode: 'e772',
      unicode_decimal: 59250,
    },
    {
      icon_id: '32520494',
      name: '0_态势感知',
      font_class: 'icon-taishiganzhi',
      unicode: 'e791',
      unicode_decimal: 59281,
    },
    {
      icon_id: '42937010',
      name: '缩小_fill',
      font_class: 'suoxiao1',
      unicode: 'e851',
      unicode_decimal: 59473,
    },
    {
      icon_id: '9552074',
      name: '放大_fill',
      font_class: 'enlarge_fill',
      unicode: 'e6f4',
      unicode_decimal: 59124,
    },
    {
      icon_id: '3216582',
      name: '地图',
      font_class: 'ditu2',
      unicode: 'e6f1',
      unicode_decimal: 59121,
    },
    {
      icon_id: '22533633',
      name: '地图',
      font_class: 'ditu1',
      unicode: 'e6ef',
      unicode_decimal: 59119,
    },
    {
      icon_id: '1435242',
      name: '首页填充',
      font_class: 'shouyetianchong',
      unicode: 'e6e3',
      unicode_decimal: 59107,
    },
    {
      icon_id: '39210916',
      name: '手动报警装置_未选中',
      font_class: 'shoudongbaojingzhuangzhi_weixuanzhong',
      unicode: 'e6e2',
      unicode_decimal: 59106,
    },
    {
      icon_id: '42888866',
      name: 'aifengkong',
      font_class: 'aifengkong',
      unicode: 'e84f',
      unicode_decimal: 59471,
    },
    {
      icon_id: '11459723',
      name: '消息',
      font_class: 'xiaoxi',
      unicode: 'e6df',
      unicode_decimal: 59103,
    },
    {
      icon_id: '18588638',
      name: '危化品',
      font_class: 'weihuapin',
      unicode: 'e6de',
      unicode_decimal: 59102,
    },
    {
      icon_id: '15628572',
      name: '库存查询2',
      font_class: 'kucunchaxun2',
      unicode: 'e6d9',
      unicode_decimal: 59097,
    },
    {
      icon_id: '39642222',
      name: '静音',
      font_class: 'jingyin2',
      unicode: 'e6db',
      unicode_decimal: 59099,
    },
    {
      icon_id: '39642223',
      name: '音量',
      font_class: 'yinliang1',
      unicode: 'e6dd',
      unicode_decimal: 59101,
    },
    {
      icon_id: '13543421',
      name: '危化品信息',
      font_class: 'weihuapinxinxibeifen',
      unicode: 'e7cc',
      unicode_decimal: 59340,
    },
    {
      icon_id: '26650278',
      name: '处置方法',
      font_class: 'a-v114shiyongfangfa',
      unicode: 'e6ce',
      unicode_decimal: 59086,
    },
    {
      icon_id: '35203576',
      name: '管控制度',
      font_class: 'a-zhidu11',
      unicode: 'e918',
      unicode_decimal: 59672,
    },
    {
      icon_id: '36192100',
      name: '出入库',
      font_class: 'churuku1',
      unicode: 'e6d2',
      unicode_decimal: 59090,
    },
    {
      icon_id: '4942642',
      name: '更多',
      font_class: 'gengduo2',
      unicode: 'e6d8',
      unicode_decimal: 59096,
    },
    {
      icon_id: '42483288',
      name: '微型',
      font_class: 'weixing',
      unicode: 'e84e',
      unicode_decimal: 59470,
    },
    {
      icon_id: '9032033',
      name: '催促',
      font_class: 'cuicu',
      unicode: 'e6c4',
      unicode_decimal: 59076,
    },
    {
      icon_id: '30287652',
      name: '已审核',
      font_class: 'yishenhe1',
      unicode: 'e6c3',
      unicode_decimal: 59075,
    },
    {
      icon_id: '11956304',
      name: '待办',
      font_class: 'daiban3',
      unicode: 'e6c1',
      unicode_decimal: 59073,
    },
    {
      icon_id: '12496849',
      name: '应急物资',
      font_class: 'yingjiwuzi',
      unicode: 'e6c0',
      unicode_decimal: 59072,
    },
    {
      icon_id: '28940590',
      name: '消防员',
      font_class: 'xiaofangyuan',
      unicode: 'e803',
      unicode_decimal: 59395,
    },
    {
      icon_id: '4071482',
      name: '动态报表',
      font_class: 'dynamic-report',
      unicode: 'e7b3',
      unicode_decimal: 59315,
    },
    {
      icon_id: '11830224',
      name: '报表管理',
      font_class: 'baobiaoguanli',
      unicode: 'e6ee',
      unicode_decimal: 59118,
    },
    {
      icon_id: '4060360',
      name: '已确认报告',
      font_class: 'yiquerenbaogao',
      unicode: 'e6be',
      unicode_decimal: 59070,
    },
    {
      icon_id: '7957905',
      name: '维修',
      font_class: 'weixiubeijing',
      unicode: 'e6bb',
      unicode_decimal: 59067,
    },
    {
      icon_id: '37938572',
      name: '角标',
      font_class: 'jiaobiao8',
      unicode: 'e718',
      unicode_decimal: 59160,
    },
    {
      icon_id: '29790540',
      name: 'vr',
      font_class: 'a-vr1',
      unicode: 'e6ba',
      unicode_decimal: 59066,
    },
    {
      icon_id: '41844900',
      name: 'AI大模型',
      font_class: 'AIdamoxing',
      unicode: 'e746',
      unicode_decimal: 59206,
    },
    {
      icon_id: '29084337',
      name: '化工设备',
      font_class: 'huagongshebei',
      unicode: 'ef90',
      unicode_decimal: 61328,
    },
    {
      icon_id: '34476363',
      name: '消防装备产品',
      font_class: 'xiaofangzhuangbeichanpin',
      unicode: 'e78e',
      unicode_decimal: 59278,
    },
    {
      icon_id: '36095518',
      name: '电瓶电压',
      font_class: 'dianpingdianya',
      unicode: 'e6b9',
      unicode_decimal: 59065,
    },
    {
      icon_id: '34694751',
      name: '气压',
      font_class: 'qiya1',
      unicode: 'e6b7',
      unicode_decimal: 59063,
    },
    {
      icon_id: '36514093',
      name: '消防水带',
      font_class: 'xiaofangshuidai',
      unicode: 'e6b6',
      unicode_decimal: 59062,
    },
    {
      icon_id: '2477520',
      name: '消防水箱:水池',
      font_class: 'xiaofangshuixiangshuichi',
      unicode: 'e6ab',
      unicode_decimal: 59051,
    },
    {
      icon_id: '4123791',
      name: '消防员',
      font_class: 'CityWorks-',
      unicode: 'e6a8',
      unicode_decimal: 59048,
    },
    {
      icon_id: '17564385',
      name: '救援队',
      font_class: 'jiuyuandui',
      unicode: 'e6a9',
      unicode_decimal: 59049,
    },
    {
      icon_id: '23109956',
      name: '社会救助',
      font_class: 'shehuijiuzhu',
      unicode: 'e6aa',
      unicode_decimal: 59050,
    },
    {
      icon_id: '20222374',
      name: '报警',
      font_class: 'baojing',
      unicode: 'e6a7',
      unicode_decimal: 59047,
    },
    {
      icon_id: '4033831',
      name: '时间',
      font_class: 'shijian2',
      unicode: 'e6d1',
      unicode_decimal: 59089,
    },
    {
      icon_id: '29526812',
      name: '状态-成功_状态-成功',
      font_class: 'zhuangtai-chenggong_zhuangtai-chenggong',
      unicode: 'e6a2',
      unicode_decimal: 59042,
    },
    {
      icon_id: '42250542',
      name: '离线',
      font_class: 'lixian',
      unicode: 'e84d',
      unicode_decimal: 59469,
    },
    {
      icon_id: '17400662',
      name: '右滑 向右 更多',
      font_class: 'youhuaxiangyougengduo',
      unicode: 'e6a1',
      unicode_decimal: 59041,
    },
    {
      icon_id: '26009807',
      name: '烟花爆竹',
      font_class: 'yanhuabaozhu2',
      unicode: 'e696',
      unicode_decimal: 59030,
    },
    {
      icon_id: '27258270',
      name: '水库水面',
      font_class: 'shuikushuimian',
      unicode: 'eac8',
      unicode_decimal: 60104,
    },
    {
      icon_id: '29249647',
      name: '江河流域',
      font_class: 'jiangheliuyu',
      unicode: 'e8ca',
      unicode_decimal: 59594,
    },
    {
      icon_id: '29553423',
      name: '地图标点_未选中',
      font_class: 'ditubiaodian_weixuanzhong',
      unicode: 'e69f',
      unicode_decimal: 59039,
    },
    {
      icon_id: '34893550',
      name: '湖泊',
      font_class: 'hubo1',
      unicode: 'e6a0',
      unicode_decimal: 59040,
    },
    {
      icon_id: '41463745',
      name: 'mti-加油站',
      font_class: 'mti-jiayouzhan',
      unicode: 'e728',
      unicode_decimal: 59176,
    },
    {
      icon_id: '3751785',
      name: '化工',
      font_class: 'huagong',
      unicode: 'e6b4',
      unicode_decimal: 59060,
    },
    {
      icon_id: '5101734',
      name: '商业综合体',
      font_class: 'jianzhu',
      unicode: 'e783',
      unicode_decimal: 59267,
    },
    {
      icon_id: '18866740',
      name: '九小场所',
      font_class: 'jiuxiaochangsuo',
      unicode: 'e695',
      unicode_decimal: 59029,
    },
    {
      icon_id: '27165624',
      name: '重点单位',
      font_class: 'zhongdiandanwei',
      unicode: 'e6cf',
      unicode_decimal: 59087,
    },
    {
      icon_id: '41463725',
      name: 'mti-隧道',
      font_class: 'mti-suidao',
      unicode: 'e727',
      unicode_decimal: 59175,
    },
    {
      icon_id: '5432440',
      name: '大楼',
      font_class: 'dalou',
      unicode: 'e694',
      unicode_decimal: 59028,
    },
    {
      icon_id: '14445798',
      name: '曲线图',
      font_class: 'quxiantu1',
      unicode: 'e680',
      unicode_decimal: 59008,
    },
    {
      icon_id: '7594076',
      name: '24gl-repeatInfinite',
      font_class: 'repeatInfinite',
      unicode: 'ea74',
      unicode_decimal: 60020,
    },
    {
      icon_id: '37904068',
      name: '如果',
      font_class: 'ruguo',
      unicode: 'e67d',
      unicode_decimal: 59005,
    },
    {
      icon_id: '37176377',
      name: '移离参考点',
      font_class: 'yilicankaodiandeshuangxiangxiaoyinghuozuoyong',
      unicode: 'e6ec',
      unicode_decimal: 59116,
    },
    {
      icon_id: '4766953',
      name: 'error',
      font_class: 'error',
      unicode: 'e801',
      unicode_decimal: 59393,
    },
    {
      icon_id: '19911799',
      name: '和',
      font_class: 'he',
      unicode: 'e67e',
      unicode_decimal: 59006,
    },
    {
      icon_id: '40958708',
      name: '取消非-非中文',
      font_class: 'quxiaofei-feizhongwen',
      unicode: 'e802',
      unicode_decimal: 59394,
    },
    {
      icon_id: '16077832',
      name: '夜晚',
      font_class: 'yewan',
      unicode: 'e8c9',
      unicode_decimal: 59593,
    },
    {
      icon_id: '19445022',
      name: '晚上',
      font_class: 'wanshang2',
      unicode: 'e67f',
      unicode_decimal: 59007,
    },
    {
      icon_id: '27604415',
      name: '日出',
      font_class: 'richu',
      unicode: 'ea6e',
      unicode_decimal: 60014,
    },
    {
      icon_id: '27604416',
      name: '日落',
      font_class: 'rila',
      unicode: 'ea6f',
      unicode_decimal: 60015,
    },
    {
      icon_id: '37661439',
      name: '夜晚',
      font_class: 'yewan1',
      unicode: 'e691',
      unicode_decimal: 59025,
    },
    {
      icon_id: '26956714',
      name: '灭火器',
      font_class: 'a-configurationoffireextinguishersinbuildings-f',
      unicode: 'e67a',
      unicode_decimal: 59002,
    },
    {
      icon_id: '42006523',
      name: '建筑',
      font_class: 'jianzhu3',
      unicode: 'e84a',
      unicode_decimal: 59466,
    },
    {
      icon_id: '42006524',
      name: '联动单位',
      font_class: 'liandongdanwei',
      unicode: 'e84c',
      unicode_decimal: 59468,
    },
    {
      icon_id: '19794559',
      name: '消防_专职消防队',
      font_class: 'xiaofang_zhuanzhixiaofangdui',
      unicode: 'e86d',
      unicode_decimal: 59501,
    },
    {
      icon_id: '7876797',
      name: '订阅',
      font_class: 'dingyue',
      unicode: 'e679',
      unicode_decimal: 59001,
    },
    {
      icon_id: '41988073',
      name: '消防车',
      font_class: 'xiaofangche4',
      unicode: 'e849',
      unicode_decimal: 59465,
    },
    {
      icon_id: '7465638',
      name: '主页',
      font_class: 'zhuye1',
      unicode: 'e931',
      unicode_decimal: 59697,
    },
    {
      icon_id: '41972958',
      name: 'AI报警',
      font_class: 'AIbaojing',
      unicode: 'e848',
      unicode_decimal: 59464,
    },
    {
      icon_id: '41970042',
      name: '河流',
      font_class: 'heliu',
      unicode: 'e847',
      unicode_decimal: 59463,
    },
    {
      icon_id: '7045022',
      name: '管道',
      font_class: 'guandao1',
      unicode: 'e675',
      unicode_decimal: 58997,
    },
    {
      icon_id: '41968727',
      name: '重点建筑',
      font_class: 'zhongdianjianzhu1',
      unicode: 'e846',
      unicode_decimal: 59462,
    },
    {
      icon_id: '6155645',
      name: '道路',
      font_class: 'daolu1',
      unicode: 'e68f',
      unicode_decimal: 59023,
    },
    {
      icon_id: '5124629',
      name: '人员组织',
      font_class: 'huaban1',
      unicode: 'e674',
      unicode_decimal: 58996,
    },
    {
      icon_id: '32710116',
      name: '非传统水源.',
      font_class: 'a-feichuantongshuiyuan',
      unicode: 'e66f',
      unicode_decimal: 58991,
    },
    {
      icon_id: '12388829',
      name: '我的医院',
      font_class: 'wodeyiyuan',
      unicode: 'e693',
      unicode_decimal: 59027,
    },
    {
      icon_id: '5273843',
      name: '死亡人员',
      font_class: 'siwangrenyuan',
      unicode: 'e788',
      unicode_decimal: 59272,
    },
    {
      icon_id: '20120910',
      name: '消防站',
      font_class: 'xiaofangzhan',
      unicode: 'e78d',
      unicode_decimal: 59277,
    },
    {
      icon_id: '41778317',
      name: '消防管理-消防巡查',
      font_class: 'xiaofangguanli-xiaofangxuncha',
      unicode: 'e769',
      unicode_decimal: 59241,
    },
    {
      icon_id: '26829870',
      name: '面积',
      font_class: 'mianji',
      unicode: 'e782',
      unicode_decimal: 59266,
    },
    {
      icon_id: '38986170',
      name: '人口动态-人口扩张',
      font_class: 'renkoudongtai-renkoukuozhang',
      unicode: 'e77f',
      unicode_decimal: 59263,
    },
    {
      icon_id: '27971138',
      name: '流动人口基本信息',
      font_class: 'liudongrenkoujibenxinxi',
      unicode: 'e76e',
      unicode_decimal: 59246,
    },
    {
      icon_id: '29358851',
      name: 'icon／实有人口',
      font_class: 'a-iconshiyourenkou',
      unicode: 'e786',
      unicode_decimal: 59270,
    },
    {
      icon_id: '11665663',
      name: '安全隐患',
      font_class: 'anquanyinhuan',
      unicode: 'e8b3',
      unicode_decimal: 59571,
    },
    {
      icon_id: '41943494',
      name: '图层',
      font_class: 'tuceng',
      unicode: 'e845',
      unicode_decimal: 59461,
    },
    {
      icon_id: '37507652',
      name: '图层-L',
      font_class: 'tuceng-L',
      unicode: 'e66d',
      unicode_decimal: 58989,
    },
    {
      icon_id: '26453068',
      name: '_人脸',
      font_class: '_renlian',
      unicode: 'e66e',
      unicode_decimal: 58990,
    },
    {
      icon_id: '39303176',
      name: '布控',
      font_class: 'zhuapai2',
      unicode: 'ed68',
      unicode_decimal: 60776,
    },
    {
      icon_id: '38256422',
      name: '算法模型',
      font_class: 'suanfamoxing',
      unicode: 'e8d3',
      unicode_decimal: 59603,
    },
    {
      icon_id: '1305472',
      name: '任务',
      font_class: 'renwu',
      unicode: 'e8b5',
      unicode_decimal: 59573,
    },
    {
      icon_id: '41927036',
      name: '目录',
      font_class: 'mulu',
      unicode: 'e843',
      unicode_decimal: 59459,
    },
    {
      icon_id: '41914788',
      name: '消防大队',
      font_class: 'xiaofangdadui',
      unicode: 'e840',
      unicode_decimal: 59456,
    },
    {
      icon_id: '41914787',
      name: '消防支队',
      font_class: 'xiaofangzhidui',
      unicode: 'e841',
      unicode_decimal: 59457,
    },
    {
      icon_id: '41914786',
      name: '消防总队',
      font_class: 'xiaofangzongdui',
      unicode: 'e842',
      unicode_decimal: 59458,
    },
    {
      icon_id: '2944649',
      name: '执法车',
      font_class: 'zhifache',
      unicode: 'e858',
      unicode_decimal: 59480,
    },
    {
      icon_id: '12007042',
      name: '空气质量',
      font_class: 'kongqizhiliang',
      unicode: 'e856',
      unicode_decimal: 59478,
    },
    {
      icon_id: '23722059',
      name: '执法人员',
      font_class: 'zhifarenyuan',
      unicode: 'e864',
      unicode_decimal: 59492,
    },
    {
      icon_id: '33317322',
      name: '水质监测',
      font_class: 'shuizhijiance',
      unicode: 'e86f',
      unicode_decimal: 59503,
    },
    {
      icon_id: '24101090',
      name: '短信管理',
      font_class: 'duanxinguanli',
      unicode: 'e75d',
      unicode_decimal: 59229,
    },
    {
      icon_id: '18636764',
      name: '模型管理',
      font_class: 'moxingguanli1',
      unicode: 'e74d',
      unicode_decimal: 59213,
    },
    {
      icon_id: '18383831',
      name: '智能报表',
      font_class: 'kaoqinbaobiao',
      unicode: 'e742',
      unicode_decimal: 59202,
    },
    {
      icon_id: '5588946',
      name: 'ＰＭ1.0',
      font_class: 'icon-test',
      unicode: 'e735',
      unicode_decimal: 59189,
    },
    {
      icon_id: '28606915',
      name: 'PM2.5_面',
      font_class: 'a-PM25_mian',
      unicode: 'e730',
      unicode_decimal: 59184,
    },
    {
      icon_id: '28606926',
      name: 'PM10_面',
      font_class: 'PM10_mian',
      unicode: 'e738',
      unicode_decimal: 59192,
    },
    {
      icon_id: '28606946',
      name: '二氧化碳_面',
      font_class: 'eryanghuatan_mian',
      unicode: 'e733',
      unicode_decimal: 59187,
    },
    {
      icon_id: '9730111',
      name: '湿度 ',
      font_class: 'shidu3',
      unicode: 'e8d7',
      unicode_decimal: 59607,
    },
    {
      icon_id: '11966613',
      name: '正常',
      font_class: 'zhengchang1',
      unicode: 'e665',
      unicode_decimal: 58981,
    },
    {
      icon_id: '1351',
      name: '向下',
      font_class: 'xiangxia',
      unicode: 'e721',
      unicode_decimal: 59169,
    },
    {
      icon_id: '36605894',
      name: '倾角、角度',
      font_class: 'a-qingjiaojiaodu',
      unicode: 'e6c2',
      unicode_decimal: 59074,
    },
    {
      icon_id: '35087768',
      name: '电量',
      font_class: 'battery-2-charge-fill',
      unicode: 'e720',
      unicode_decimal: 59168,
    },
    {
      icon_id: '11419972',
      name: '液位',
      font_class: 'yewei1',
      unicode: 'e68e',
      unicode_decimal: 59022,
    },
    {
      icon_id: '1280',
      name: '大缩略图列表',
      font_class: 'dasuolvetuliebiao',
      unicode: 'e707',
      unicode_decimal: 59143,
    },
    {
      icon_id: '1282',
      name: '列表',
      font_class: 'liebiao1',
      unicode: 'e708',
      unicode_decimal: 59144,
    },
    {
      icon_id: '41740845',
      name: '信号2',
      font_class: 'xinhao2',
      unicode: 'e83d',
      unicode_decimal: 59453,
    },
    {
      icon_id: '41740844',
      name: '信号1',
      font_class: 'xinhao1',
      unicode: 'e83e',
      unicode_decimal: 59454,
    },
    {
      icon_id: '41740843',
      name: '信号3',
      font_class: 'xinhao3',
      unicode: 'e83f',
      unicode_decimal: 59455,
    },
    {
      icon_id: '32538038',
      name: '网络信号',
      font_class: 'wangluoxinhao',
      unicode: 'e9cd',
      unicode_decimal: 59853,
    },
    {
      icon_id: '41082825',
      name: '烟雾传感器',
      font_class: 'yanwuchuanganqi1',
      unicode: 'e6fc',
      unicode_decimal: 59132,
    },
    {
      icon_id: '35679380',
      name: '内容管理',
      font_class: 'neirongguanli',
      unicode: 'e663',
      unicode_decimal: 58979,
    },
    {
      icon_id: '41727635',
      name: '空数据',
      font_class: 'kongshuju',
      unicode: 'e83c',
      unicode_decimal: 59452,
    },
    {
      icon_id: '34763349',
      name: '巡检轨迹',
      font_class: 'xunjianguiji',
      unicode: 'e83b',
      unicode_decimal: 59451,
    },
    {
      icon_id: '14112848',
      name: '安全',
      font_class: 'anquan',
      unicode: 'e661',
      unicode_decimal: 58977,
    },
    {
      icon_id: '12197084',
      name: '电流',
      font_class: 'dianliu',
      unicode: 'e6e1',
      unicode_decimal: 59105,
    },
    {
      icon_id: '12197089',
      name: '电压',
      font_class: 'dianya',
      unicode: 'e6d7',
      unicode_decimal: 59095,
    },
    {
      icon_id: '41061908',
      name: '漏电流',
      font_class: 'loudianliu',
      unicode: 'e66a',
      unicode_decimal: 58986,
    },
    {
      icon_id: '20921544',
      name: '温度 (1)',
      font_class: 'wendu11',
      unicode: 'e678',
      unicode_decimal: 59000,
    },
    {
      icon_id: '15643743',
      name: '微信运营',
      font_class: 'weixinyunying',
      unicode: 'e6b3',
      unicode_decimal: 59059,
    },
    {
      icon_id: '1983661',
      name: '地图',
      font_class: 'ditu',
      unicode: 'e65d',
      unicode_decimal: 58973,
    },
    {
      icon_id: '4251775',
      name: '证件',
      font_class: 'zhengjian',
      unicode: 'e6d0',
      unicode_decimal: 59088,
    },
    {
      icon_id: '9184411',
      name: '哭脸',
      font_class: 'kulian4',
      unicode: 'e6b8',
      unicode_decimal: 59064,
    },
    {
      icon_id: '11982349',
      name: '笑脸',
      font_class: 'xiaolian2',
      unicode: 'e6b2',
      unicode_decimal: 59058,
    },
    {
      icon_id: '36491247',
      name: '航点',
      font_class: 'hangdian',
      unicode: 'e82a',
      unicode_decimal: 59434,
    },
    {
      icon_id: '38450325',
      name: '续航',
      font_class: 'xuhang',
      unicode: 'e65c',
      unicode_decimal: 58972,
    },
    {
      icon_id: '17918933',
      name: 'ZS评价次数',
      font_class: 'ZSpingjiacishu',
      unicode: 'e69e',
      unicode_decimal: 59038,
    },
    {
      icon_id: '41590389',
      name: '作业次数',
      font_class: 'zuoyecishu',
      unicode: 'e83a',
      unicode_decimal: 59450,
    },
    {
      icon_id: '20923807',
      name: '飞手',
      font_class: 'feishou',
      unicode: 'e816',
      unicode_decimal: 59414,
    },
    {
      icon_id: '28159773',
      name: 'jiqigou',
      font_class: 'jiqigou',
      unicode: 'e829',
      unicode_decimal: 59433,
    },
    {
      icon_id: '1730473',
      name: '曲线图',
      font_class: 'quxiantu',
      unicode: 'e68d',
      unicode_decimal: 59021,
    },
    {
      icon_id: '39770471',
      name: '高度',
      font_class: 'gaodu',
      unicode: 'e919',
      unicode_decimal: 59673,
    },
    {
      icon_id: '15391366',
      name: '信号',
      font_class: 'xinhao',
      unicode: 'e656',
      unicode_decimal: 58966,
    },
    {
      icon_id: '29858199',
      name: '路线',
      font_class: 'luxian',
      unicode: 'e689',
      unicode_decimal: 59017,
    },
    {
      icon_id: '41089147',
      name: '树-摄像头-离线',
      font_class: 'shu-shexiangtou-lixian',
      unicode: 'e67b',
      unicode_decimal: 59003,
    },
    {
      icon_id: '34166783',
      name: '秒表',
      font_class: 'miaobiao1',
      unicode: 'e669',
      unicode_decimal: 58985,
    },
    {
      icon_id: '8220794',
      name: '名称-检查设置',
      font_class: 'mc-jcsz',
      unicode: 'e828',
      unicode_decimal: 59432,
    },
    {
      icon_id: '29865166',
      name: '关闭',
      font_class: 'guanbi',
      unicode: 'e681',
      unicode_decimal: 59009,
    },
    {
      icon_id: '2247619',
      name: '无人机',
      font_class: 'wurenji2',
      unicode: 'e807',
      unicode_decimal: 59399,
    },
    {
      icon_id: '725952',
      name: '时间',
      font_class: 'shijian1',
      unicode: 'e652',
      unicode_decimal: 58962,
    },
    {
      icon_id: '9557969',
      name: '工人',
      font_class: 'gongren3',
      unicode: 'e6d5',
      unicode_decimal: 59093,
    },
    {
      icon_id: '14742574',
      name: '风速',
      font_class: 'fengsu',
      unicode: 'e855',
      unicode_decimal: 59477,
    },
    {
      icon_id: '19985076',
      name: '电池-满电',
      font_class: 'dianchi-mandian',
      unicode: 'e7a4',
      unicode_decimal: 59300,
    },
    {
      icon_id: '19985098',
      name: '电池-高电量',
      font_class: 'dianchi-gaodianliang',
      unicode: 'e7a5',
      unicode_decimal: 59301,
    },
    {
      icon_id: '19985102',
      name: '电池-中电量',
      font_class: 'dianchi-zhongdianliang',
      unicode: 'e7a8',
      unicode_decimal: 59304,
    },
    {
      icon_id: '19985106',
      name: '电池-低电量',
      font_class: 'dianchi-didianliang',
      unicode: 'e7a9',
      unicode_decimal: 59305,
    },
    {
      icon_id: '36806945',
      name: '卫星云图icon',
      font_class: 'weixingyuntuicon',
      unicode: 'e653',
      unicode_decimal: 58963,
    },
    {
      icon_id: '10299108',
      name: '待审核',
      font_class: 'daishenhe',
      unicode: 'e651',
      unicode_decimal: 58961,
    },
    {
      icon_id: '1766470',
      name: '符号-按钮',
      font_class: 'anniu1',
      unicode: 'e690',
      unicode_decimal: 59024,
    },
    {
      icon_id: '34511429',
      name: 'U盾',
      font_class: 'a-Udun_huaban1',
      unicode: 'e650',
      unicode_decimal: 58960,
    },
    {
      icon_id: '41372504',
      name: '数据资产',
      font_class: 'shujuzichan1',
      unicode: 'e839',
      unicode_decimal: 59449,
    },
    {
      icon_id: '41291902',
      name: '采集成功',
      font_class: 'caijichenggong',
      unicode: 'e835',
      unicode_decimal: 59445,
    },
    {
      icon_id: '41291901',
      name: '采集失败',
      font_class: 'caijishibai',
      unicode: 'e836',
      unicode_decimal: 59446,
    },
    {
      icon_id: '41291900',
      name: '采集执行中',
      font_class: 'caijizhihangzhong',
      unicode: 'e838',
      unicode_decimal: 59448,
    },
    {
      icon_id: '3961077',
      name: '进度查询',
      font_class: 'jinduchaxun',
      unicode: 'e64f',
      unicode_decimal: 58959,
    },
    {
      icon_id: '11684491',
      name: '批量执行',
      font_class: 'piliangzhihang',
      unicode: 'e701',
      unicode_decimal: 59137,
    },
    {
      icon_id: '36181796',
      name: 'icon-批量修改',
      font_class: 'icon-piliangxiugai',
      unicode: 'e670',
      unicode_decimal: 58992,
    },
    {
      icon_id: '31199780',
      name: '批量复制',
      font_class: 'piliangfuzhi',
      unicode: 'e73f',
      unicode_decimal: 59199,
    },
    {
      icon_id: '29550243',
      name: '映射',
      font_class: 'yingshe1',
      unicode: 'e671',
      unicode_decimal: 58993,
    },
    {
      icon_id: '37247906',
      name: '字段',
      font_class: 'ziduan5',
      unicode: 'e64e',
      unicode_decimal: 58958,
    },
    {
      icon_id: '41232530',
      name: '设备在线',
      font_class: 'shebeizaixian',
      unicode: 'e834',
      unicode_decimal: 59444,
    },
    {
      icon_id: '41232521',
      name: '连接断开',
      font_class: 'lianjieduankai1',
      unicode: 'e833',
      unicode_decimal: 59443,
    },
    {
      icon_id: '15552225',
      name: '连接',
      font_class: 'lianjie2',
      unicode: 'e677',
      unicode_decimal: 58999,
    },
    {
      icon_id: '5262897',
      name: '彩色-箭头-向上-1',
      font_class: 'cs-jt-xs-1-1',
      unicode: 'e67c',
      unicode_decimal: 59004,
    },
    {
      icon_id: '12572581',
      name: '安保',
      font_class: 'anbao',
      unicode: 'e688',
      unicode_decimal: 59016,
    },
    {
      icon_id: '14978152',
      name: '专业人员',
      font_class: 'gongren21',
      unicode: 'e64c',
      unicode_decimal: 58956,
    },
    {
      icon_id: '41196498',
      name: '脱岗',
      font_class: 'tuogang',
      unicode: 'e832',
      unicode_decimal: 59442,
    },
    {
      icon_id: '383685',
      name: '实五角星',
      font_class: 'shiwujiaoxing',
      unicode: 'e64b',
      unicode_decimal: 58955,
    },
    {
      icon_id: '955983',
      name: '对勾',
      font_class: 'duigou',
      unicode: 'e648',
      unicode_decimal: 58952,
    },
    {
      icon_id: '40990202',
      name: '保安',
      font_class: 'baoan1',
      unicode: 'e70e',
      unicode_decimal: 59150,
    },
    {
      icon_id: '19317253',
      name: '评价',
      font_class: 'pingjia',
      unicode: 'f09b',
      unicode_decimal: 61595,
    },
    {
      icon_id: '41086426',
      name: '处理中',
      font_class: 'chulizhong',
      unicode: 'e830',
      unicode_decimal: 59440,
    },
    {
      icon_id: '22480879',
      name: '已审核',
      font_class: 'yishenhe',
      unicode: 'e647',
      unicode_decimal: 58951,
    },
    {
      icon_id: '25365587',
      name: '跟踪问效',
      font_class: 'shangjigenzong',
      unicode: 'e646',
      unicode_decimal: 58950,
    },
    {
      icon_id: '41056685',
      name: '未处理',
      font_class: 'weichuli1',
      unicode: 'e82c',
      unicode_decimal: 59436,
    },
    {
      icon_id: '12331689',
      name: '指标',
      font_class: 'zhibiao',
      unicode: 'e66c',
      unicode_decimal: 58988,
    },
    {
      icon_id: '36238628',
      name: '指标说明',
      font_class: 'zhibiaoshuoming',
      unicode: 'e6cb',
      unicode_decimal: 59083,
    },
    {
      icon_id: '38417242',
      name: '计算方式',
      font_class: 'jisuanfangshi',
      unicode: 'e645',
      unicode_decimal: 58949,
    },
    {
      icon_id: '20543829',
      name: '监督整改',
      font_class: 'jianduzhenggai',
      unicode: 'e9d0',
      unicode_decimal: 59856,
    },
    {
      icon_id: '2945800',
      name: '审核通过',
      font_class: 'shenhetongguo',
      unicode: 'e641',
      unicode_decimal: 58945,
    },
    {
      icon_id: '18290899',
      name: '隐患点',
      font_class: 'yinhuandian',
      unicode: 'e642',
      unicode_decimal: 58946,
    },
    {
      icon_id: '36284719',
      name: '安全检查_filled',
      font_class: 'anquanjiancha_filled',
      unicode: 'e644',
      unicode_decimal: 58948,
    },
    {
      icon_id: '5651356',
      name: '饼图统计',
      font_class: 'bingtutongji',
      unicode: 'e662',
      unicode_decimal: 58978,
    },
    {
      icon_id: '21433107',
      name: '值班人员',
      font_class: 'zhibanrenyuan',
      unicode: 'e64a',
      unicode_decimal: 58954,
    },
    {
      icon_id: '24632518',
      name: '面  在岗人员',
      font_class: 'a-mianzaigangrenyuan',
      unicode: 'e69c',
      unicode_decimal: 59036,
    },
    {
      icon_id: '26345229',
      name: '消控室',
      font_class: 'xiaokongshi',
      unicode: 'e9c3',
      unicode_decimal: 59843,
    },
    {
      icon_id: '5767772',
      name: '物资管理',
      font_class: 'wuziguanli',
      unicode: 'e698',
      unicode_decimal: 59032,
    },
    {
      icon_id: '1510287',
      name: '提交',
      font_class: 'tijiao',
      unicode: 'e640',
      unicode_decimal: 58944,
    },
    {
      icon_id: '32852154',
      name: '督查问题',
      font_class: 'duchawenti',
      unicode: 'e7c1',
      unicode_decimal: 59329,
    },
    {
      icon_id: '36284721',
      name: '安全检查_line',
      font_class: 'anquanjiancha_line',
      unicode: 'e63f',
      unicode_decimal: 58943,
    },
    {
      icon_id: '27348688',
      name: '复查',
      font_class: 'zipai-beifuchashuai',
      unicode: 'e7a3',
      unicode_decimal: 59299,
    },
    {
      icon_id: '33576467',
      name: '执行任务',
      font_class: 'zhihangfankui2',
      unicode: 'e956',
      unicode_decimal: 59734,
    },
    {
      icon_id: '16563751',
      name: '确认',
      font_class: 'cangpeitubiao_querenrukuquerenchukuquerenpandianjieguo',
      unicode: 'e624',
      unicode_decimal: 58916,
    },
    {
      icon_id: '6677877',
      name: '已完成',
      font_class: 'yiwancheng2',
      unicode: 'e622',
      unicode_decimal: 58914,
    },
    {
      icon_id: '25928271',
      name: '风险监测',
      font_class: 'fengxianjiance',
      unicode: 'e621',
      unicode_decimal: 58913,
    },
    {
      icon_id: '13923926',
      name: '电话',
      font_class: 'dianhua5',
      unicode: 'e8f2',
      unicode_decimal: 59634,
    },
    {
      icon_id: '32710474',
      name: '留样管理',
      font_class: 'liuyang',
      unicode: 'e913',
      unicode_decimal: 59667,
    },
    {
      icon_id: '35203570',
      name: '制度 (3)',
      font_class: 'a-zhidu3',
      unicode: 'eb1a',
      unicode_decimal: 60186,
    },
    {
      icon_id: '5027',
      name: '手机',
      font_class: 'shouji',
      unicode: 'e620',
      unicode_decimal: 58912,
    },
    {
      icon_id: '7639379',
      name: '实心圆形',
      font_class: 'shixinyuanxing',
      unicode: 'e8e1',
      unicode_decimal: 59617,
    },
    {
      icon_id: '26060540',
      name: '多边形',
      font_class: 'polygon-fill',
      unicode: 'e8e4',
      unicode_decimal: 59620,
    },
    {
      icon_id: '7556894',
      name: '正确',
      font_class: 'zhengque',
      unicode: 'e61f',
      unicode_decimal: 58911,
    },
    {
      icon_id: '14322131',
      name: '应急装备 ',
      font_class: 'yingjizhuangbei1',
      unicode: 'e969',
      unicode_decimal: 59753,
    },
    {
      icon_id: '19069339',
      name: '详情',
      font_class: 'xiangqingye-38',
      unicode: 'e947',
      unicode_decimal: 59719,
    },
    {
      icon_id: '9175139',
      name: '批量下载',
      font_class: 'piliangxiazai',
      unicode: 'e63e',
      unicode_decimal: 58942,
    },
    {
      icon_id: '1368552',
      name: '预览',
      font_class: 'print-view',
      unicode: 'e61e',
      unicode_decimal: 58910,
    },
    {
      icon_id: '12648418',
      name: '移除',
      font_class: 'yichu',
      unicode: 'e975',
      unicode_decimal: 59765,
    },
    {
      icon_id: '659272',
      name: '坐标点',
      font_class: 'zuobiaodian',
      unicode: 'e635',
      unicode_decimal: 58933,
    },
    {
      icon_id: '10960460',
      name: '追踪',
      font_class: 'zhuizong',
      unicode: 'e6cc',
      unicode_decimal: 59084,
    },
    {
      icon_id: '504568',
      name: '复制',
      font_class: 'fuzhi',
      unicode: 'e8dc',
      unicode_decimal: 59612,
    },
    {
      icon_id: '525992',
      name: '更多',
      font_class: 'gengduo',
      unicode: 'e61c',
      unicode_decimal: 58908,
    },
    {
      icon_id: '22480686',
      name: '未通过',
      font_class: 'weitongguo',
      unicode: 'e61b',
      unicode_decimal: 58907,
    },
    {
      icon_id: '10299105',
      name: '已完成',
      font_class: 'yiwancheng',
      unicode: 'e609',
      unicode_decimal: 58889,
    },
    {
      icon_id: '10807616',
      name: '系统_添加设备',
      font_class: 'xitong_tianjiashebei',
      unicode: 'e608',
      unicode_decimal: 58888,
    },
    {
      icon_id: '4784134',
      name: '添加',
      font_class: 'yaoqing',
      unicode: 'e660',
      unicode_decimal: 58976,
    },
    {
      icon_id: '22864451',
      name: '工人',
      font_class: 'gongren2',
      unicode: 'e8d6',
      unicode_decimal: 59606,
    },
    {
      icon_id: '40775704',
      name: '静音',
      font_class: 'jingyin',
      unicode: 'e825',
      unicode_decimal: 59429,
    },
    {
      icon_id: '40775703',
      name: '语音',
      font_class: 'yuyin',
      unicode: 'e826',
      unicode_decimal: 59430,
    },
    {
      icon_id: '12712668',
      name: '截屏',
      font_class: 'jieping1',
      unicode: 'e8cb',
      unicode_decimal: 59595,
    },
    {
      icon_id: '23405124',
      name: '旋转',
      font_class: 'xuanzhuan1',
      unicode: 'e8cc',
      unicode_decimal: 59596,
    },
    {
      icon_id: '31223915',
      name: '云台控制',
      font_class: 'yuntaikongzhi',
      unicode: 'e8cd',
      unicode_decimal: 59597,
    },
    {
      icon_id: '33812115',
      name: '提示2',
      font_class: 'tishi21',
      unicode: 'e8ce',
      unicode_decimal: 59598,
    },
    {
      icon_id: '4182367',
      name: 'AK-MN_声音',
      font_class: 'mn_shengyin',
      unicode: 'e605',
      unicode_decimal: 58885,
    },
    {
      icon_id: '35247988',
      name: '投屏',
      font_class: 'touping1',
      unicode: 'e6f2',
      unicode_decimal: 59122,
    },
    {
      icon_id: '39320812',
      name: '取消置顶',
      font_class: 'quxiaozhiding4',
      unicode: 'e8c6',
      unicode_decimal: 59590,
    },
    {
      icon_id: '39320814',
      name: '置顶',
      font_class: 'zhiding1',
      unicode: 'e8c7',
      unicode_decimal: 59591,
    },
    {
      icon_id: '11017899',
      name: '21公共广播',
      font_class: 'gonggongguangbo',
      unicode: 'e632',
      unicode_decimal: 58930,
    },
    {
      icon_id: '39463317',
      name: '其他-05',
      font_class: 'qita-05',
      unicode: 'ec7e',
      unicode_decimal: 60542,
    },
    {
      icon_id: '36575884',
      name: '即时回放-填充',
      font_class: 'jishihuifang-tianchong',
      unicode: 'e8bc',
      unicode_decimal: 59580,
    },
    {
      icon_id: '7762199',
      name: '终止',
      font_class: 'zhongzhi',
      unicode: 'e89a',
      unicode_decimal: 59546,
    },
    {
      icon_id: '16253312',
      name: '最短路径',
      font_class: 'zuiduanlujing1',
      unicode: 'e8d5',
      unicode_decimal: 59605,
    },
    {
      icon_id: '25029363',
      name: '气象信息',
      font_class: 'qixiangxinxi',
      unicode: 'e898',
      unicode_decimal: 59544,
    },
    {
      icon_id: '40746352',
      name: '两宫格',
      font_class: 'lianggongge',
      unicode: 'e824',
      unicode_decimal: 59428,
    },
    {
      icon_id: '7957898',
      name: '总人数',
      font_class: 'zongrenshu',
      unicode: 'e7a1',
      unicode_decimal: 59297,
    },
    {
      icon_id: '26852830',
      name: '巡检计划',
      font_class: 'xunjianjihua',
      unicode: 'e7b0',
      unicode_decimal: 59312,
    },
    {
      icon_id: '36068796',
      name: '智能设备',
      font_class: 'zhinengshebei',
      unicode: 'e7a2',
      unicode_decimal: 59298,
    },
    {
      icon_id: '39712342',
      name: '行驶里程',
      font_class: 'hangshilicheng',
      unicode: 'e7b8',
      unicode_decimal: 59320,
    },
    {
      icon_id: '6997193',
      name: '停用',
      font_class: 'tingyong1',
      unicode: 'e63b',
      unicode_decimal: 58939,
    },
    {
      icon_id: '24681220',
      name: '考试、练习、钢笔',
      font_class: 'a-kaoshilianxigangbi',
      unicode: 'e70f',
      unicode_decimal: 59151,
    },
    {
      icon_id: '25458770',
      name: '撤销审核',
      font_class: 'icon_chexiaoshenhe',
      unicode: 'e88a',
      unicode_decimal: 59530,
    },
    {
      icon_id: '5401276',
      name: '归档',
      font_class: 'guidang',
      unicode: 'e631',
      unicode_decimal: 58929,
    },
    {
      icon_id: '23112794',
      name: '消息推送',
      font_class: 'xiaoxituisong1',
      unicode: 'e82d',
      unicode_decimal: 59437,
    },
    {
      icon_id: '30734445',
      name: '指定设备',
      font_class: 'zhidingshebei',
      unicode: 'e82e',
      unicode_decimal: 59438,
    },
    {
      icon_id: '32799537',
      name: '报警记录',
      font_class: 'xiaofang-baojingjilu',
      unicode: 'e604',
      unicode_decimal: 58884,
    },
    {
      icon_id: '12253425',
      name: '未确认',
      font_class: 'weiqueren',
      unicode: 'e606',
      unicode_decimal: 58886,
    },
    {
      icon_id: '40706438',
      name: 'CBD',
      font_class: 'CBD',
      unicode: 'e823',
      unicode_decimal: 59427,
    },
    {
      icon_id: '40706300',
      name: '学校',
      font_class: 'xuexiao',
      unicode: 'e822',
      unicode_decimal: 59426,
    },
    {
      icon_id: '39593737',
      name: '公寓楼房小区',
      font_class: 'a-gongyuloufangxiaoqujiajianzhufangzi',
      unicode: 'e618',
      unicode_decimal: 58904,
    },
    {
      icon_id: '39593748',
      name: '学校房子建筑',
      font_class: 'a-xuexiaofangzijianzhu',
      unicode: 'e619',
      unicode_decimal: 58905,
    },
    {
      icon_id: '7154837',
      name: '指令管理',
      font_class: 'zhilingguanli',
      unicode: 'e62a',
      unicode_decimal: 58922,
    },
    {
      icon_id: '22349883',
      name: '数据同步',
      font_class: 'shujutongbu',
      unicode: 'f752',
      unicode_decimal: 63314,
    },
    {
      icon_id: '26440350',
      name: '流量卡',
      font_class: 'a-Group4',
      unicode: 'e80d',
      unicode_decimal: 59405,
    },
    {
      icon_id: '27052217',
      name: 'export-all',
      font_class: 'export-all',
      unicode: 'e88d',
      unicode_decimal: 59533,
    },
    {
      icon_id: '14239360',
      name: '药剂',
      font_class: 'miehuoyaoji1',
      unicode: 'e82f',
      unicode_decimal: 59439,
    },
    {
      icon_id: '3348995',
      name: '灭火器',
      font_class: 'miehuoqi',
      unicode: 'e649',
      unicode_decimal: 58953,
    },
    {
      icon_id: '19203882',
      name: '微型消防站',
      font_class: 'xingzhuang2',
      unicode: 'e7ff',
      unicode_decimal: 59391,
    },
    {
      icon_id: '35051746',
      name: '保安',
      font_class: 'baoan',
      unicode: 'e7fe',
      unicode_decimal: 59390,
    },
    {
      icon_id: '5037481',
      name: '消防车',
      font_class: 'xiaofangche2',
      unicode: 'e603',
      unicode_decimal: 58883,
    },
    {
      icon_id: '21716820',
      name: '消防车',
      font_class: 'xiaofangche3',
      unicode: 'ec43',
      unicode_decimal: 60483,
    },
    {
      icon_id: '5774446',
      name: '选择',
      font_class: 'icon-1',
      unicode: 'e7d2',
      unicode_decimal: 59346,
    },
    {
      icon_id: '37180079',
      name: '标绘',
      font_class: 'fanganbiaohui',
      unicode: 'e7fd',
      unicode_decimal: 59389,
    },
    {
      icon_id: '7193662',
      name: '时间',
      font_class: 'B-shijian',
      unicode: 'e7c9',
      unicode_decimal: 59337,
    },
    {
      icon_id: '2986910',
      name: '消防车',
      font_class: 'xiaofangche',
      unicode: 'e613',
      unicode_decimal: 58899,
    },
    {
      icon_id: '21757027',
      name: '消防车',
      font_class: 'xiaofangche1',
      unicode: 'e634',
      unicode_decimal: 58932,
    },
    {
      icon_id: '40612701',
      name: '消防车',
      font_class: 'xiaofangche-copy',
      unicode: 'e688b',
      unicode_decimal: 944267,
    },
    {
      icon_id: '4942660',
      name: '时间',
      font_class: 'shijian',
      unicode: 'e61d',
      unicode_decimal: 58909,
    },
    {
      icon_id: '11537888',
      name: '巡检',
      font_class: 'xunjiandian',
      unicode: 'e6e6',
      unicode_decimal: 59110,
    },
    {
      icon_id: '19719933',
      name: '审批人',
      font_class: 'shenheren3',
      unicode: 'e7bb',
      unicode_decimal: 59323,
    },
    {
      icon_id: '24084871',
      name: '须知',
      font_class: 'baomingxuzhi',
      unicode: 'e7ac',
      unicode_decimal: 59308,
    },
    {
      icon_id: '17029909',
      name: '申请 (2)',
      font_class: 'shenqing2',
      unicode: 'e7a0',
      unicode_decimal: 59296,
    },
    {
      icon_id: '10985471',
      name: '风险评估',
      font_class: 'fengxianpinggu1',
      unicode: 'e659',
      unicode_decimal: 58969,
    },
    {
      icon_id: '32163055',
      name: '通用传感器',
      font_class: 'tongyongchuanganqi',
      unicode: 'e942',
      unicode_decimal: 59714,
    },
    {
      icon_id: '16792995',
      name: '安全审计',
      font_class: 'anquanshenji',
      unicode: 'e673',
      unicode_decimal: 58995,
    },
    {
      icon_id: '7079546',
      name: '图片加载中',
      font_class: 'tupianjiazaizhong',
      unicode: 'e6ca',
      unicode_decimal: 59082,
    },
    {
      icon_id: '10299069',
      name: '已处理',
      font_class: 'yichuli',
      unicode: 'e601',
      unicode_decimal: 58881,
    },
    {
      icon_id: '8288619',
      name: '物联网',
      font_class: 'wulianwang1',
      unicode: 'e785',
      unicode_decimal: 59269,
    },
    {
      icon_id: '36051784',
      name: 'icon-消防主机',
      font_class: 'icon-xiaofangzhuji',
      unicode: 'e881',
      unicode_decimal: 59521,
    },
    {
      icon_id: '9110402',
      name: '卡号',
      font_class: 'kahaozu',
      unicode: 'e781',
      unicode_decimal: 59265,
    },
    {
      icon_id: '28063423',
      name: '型号',
      font_class: 'xinghao',
      unicode: 'e76a',
      unicode_decimal: 59242,
    },
    {
      icon_id: '12226270',
      name: '楼层',
      font_class: 'louceng4',
      unicode: 'e779',
      unicode_decimal: 59257,
    },
    {
      icon_id: '18621202',
      name: '复核',
      font_class: 'fuhe',
      unicode: 'e655',
      unicode_decimal: 58965,
    },
    {
      icon_id: '4933395',
      name: '实物-麦克风',
      font_class: 'shiwu-maikefeng',
      unicode: 'e764',
      unicode_decimal: 59236,
    },
    {
      icon_id: '40528142',
      name: '新建电话',
      font_class: 'xinjiandianhua',
      unicode: 'e821',
      unicode_decimal: 59425,
    },
    {
      icon_id: '20989047',
      name: '对话',
      font_class: 'yihuangoutong1',
      unicode: 'e7a7',
      unicode_decimal: 59303,
    },
    {
      icon_id: '4395546',
      name: '音量',
      font_class: 'yinliang',
      unicode: 'e664',
      unicode_decimal: 58980,
    },
    {
      icon_id: '1510389',
      name: '1检索',
      font_class: 'jiansuo',
      unicode: 'e756',
      unicode_decimal: 59222,
    },
    {
      icon_id: '17844490',
      name: '打印',
      font_class: 'dayin4',
      unicode: 'e77c',
      unicode_decimal: 59260,
    },
    {
      icon_id: '1164943',
      name: '点',
      font_class: 'dian',
      unicode: 'e62f',
      unicode_decimal: 58927,
    },
    {
      icon_id: '36205255',
      name: '移除',
      font_class: 'yichu2',
      unicode: 'e755',
      unicode_decimal: 59221,
    },
    {
      icon_id: '15473973',
      name: '返回1',
      font_class: 'fanhui1',
      unicode: 'e666',
      unicode_decimal: 58982,
    },
    {
      icon_id: '11752782',
      name: '现场管理',
      font_class: 'gonggongshiwu',
      unicode: 'e726',
      unicode_decimal: 59174,
    },
    {
      icon_id: '21944796',
      name: '视频回放',
      font_class: 'shipinhuifang5',
      unicode: 'e73b',
      unicode_decimal: 59195,
    },
    {
      icon_id: '30498703',
      name: '群组通话',
      font_class: 'qunzutonghua',
      unicode: 'e72e',
      unicode_decimal: 59182,
    },
    {
      icon_id: '10046280',
      name: '评分',
      font_class: 'dongtaixiangqingpingfen-yipingfenhuaduo',
      unicode: 'e639',
      unicode_decimal: 58937,
    },
    {
      icon_id: '9631803',
      name: '其他',
      font_class: 'qita2',
      unicode: 'e6c8',
      unicode_decimal: 59080,
    },
    {
      icon_id: '40370506',
      name: '主机故障',
      font_class: 'zhujiguzhang',
      unicode: 'e81e',
      unicode_decimal: 59422,
    },
    {
      icon_id: '1177721',
      name: '其他',
      font_class: 'qita',
      unicode: 'e683',
      unicode_decimal: 59011,
    },
    {
      icon_id: '40361795',
      name: '电量异常',
      font_class: 'dianliangyichang',
      unicode: 'e81a',
      unicode_decimal: 59418,
    },
    {
      icon_id: '40361797',
      name: '电量耗尽',
      font_class: 'dianlianghaojin',
      unicode: 'e81c',
      unicode_decimal: 59420,
    },
    {
      icon_id: '40361796',
      name: '电量健康',
      font_class: 'dianliangjiankang',
      unicode: 'e81d',
      unicode_decimal: 59421,
    },
    {
      icon_id: '8941834',
      name: '身份证',
      font_class: 'shenfenzheng',
      unicode: 'e63c',
      unicode_decimal: 58940,
    },
    {
      icon_id: '17457979',
      name: '作业报备表',
      font_class: 'zuoyebaobeibiao',
      unicode: 'e71e',
      unicode_decimal: 59166,
    },
    {
      icon_id: '27355074',
      name: '从业资格证',
      font_class: 'congyezigezheng',
      unicode: 'e6b1',
      unicode_decimal: 59057,
    },
    {
      icon_id: '21924181',
      name: '上升',
      font_class: 'shangsheng4',
      unicode: 'e685',
      unicode_decimal: 59013,
    },
    {
      icon_id: '21924182',
      name: '下降',
      font_class: 'xiajiang',
      unicode: 'e687',
      unicode_decimal: 59015,
    },
    {
      icon_id: '2472463',
      name: '新增',
      font_class: 'xinzeng1',
      unicode: 'e612',
      unicode_decimal: 58898,
    },
    {
      icon_id: '4237221',
      name: '原始角度',
      font_class: 'dituguanli',
      unicode: 'e629',
      unicode_decimal: 58921,
    },
    {
      icon_id: '26211805',
      name: '2.5D地图全景',
      font_class: 'a-3Dditu',
      unicode: 'e8b7',
      unicode_decimal: 59575,
    },
    {
      icon_id: '39829800',
      name: '3D大场景',
      font_class: 'chengshishijingsanwei',
      unicode: 'e75b',
      unicode_decimal: 59227,
    },
    {
      icon_id: '13956746',
      name: '电子地图',
      font_class: 'dianzidituzhanshi',
      unicode: 'e667',
      unicode_decimal: 58983,
    },
    {
      icon_id: '7855521',
      name: '内部结构',
      font_class: '_3d',
      unicode: 'e611',
      unicode_decimal: 58897,
    },
    {
      icon_id: '39658247',
      name: '调试工具',
      font_class: 'kuaisutiaoshi',
      unicode: 'e754',
      unicode_decimal: 59220,
    },
    {
      icon_id: '40351877',
      name: '总数',
      font_class: 'zongshu',
      unicode: 'e818',
      unicode_decimal: 59416,
    },
    {
      icon_id: '40347650',
      name: '响应时间',
      font_class: 'xiangyingshijian',
      unicode: 'e817',
      unicode_decimal: 59415,
    },
    {
      icon_id: '37330707',
      name: '跳过',
      font_class: 'tiaoguo3',
      unicode: 'e62e',
      unicode_decimal: 58926,
    },
    {
      icon_id: '2969903',
      name: '工单',
      font_class: 'gongdanchigongdanxianshi',
      unicode: 'e6c9',
      unicode_decimal: 59081,
    },
    {
      icon_id: '40318568',
      name: '隐患上报',
      font_class: 'yinhuanshangbao1',
      unicode: 'e819',
      unicode_decimal: 59417,
    },
    {
      icon_id: '6152459',
      name: '未处理',
      font_class: 'weichuli',
      unicode: 'e6da',
      unicode_decimal: 59098,
    },
    {
      icon_id: '12202557',
      name: '已完成',
      font_class: 'yiwancheng3',
      unicode: 'e71d',
      unicode_decimal: 59165,
    },
    {
      icon_id: '17767333',
      name: '火点_误报',
      font_class: 'huodian_wubao',
      unicode: 'e863',
      unicode_decimal: 59491,
    },
    {
      icon_id: '1330562',
      name: '测试',
      font_class: 'fengxianpianhaoceshi',
      unicode: 'e739',
      unicode_decimal: 59193,
    },
    {
      icon_id: '2577179',
      name: '预览',
      font_class: 'yuedu',
      unicode: 'e6e5',
      unicode_decimal: 59109,
    },
    {
      icon_id: '10384317',
      name: '主机联网',
      font_class: 'hulianwangdashuju_cu-',
      unicode: 'e6f9',
      unicode_decimal: 59129,
    },
    {
      icon_id: '15784818',
      name: '巡检',
      font_class: 'xunjian2',
      unicode: 'e74c',
      unicode_decimal: 59212,
    },
    {
      icon_id: '6298983',
      name: '检索',
      font_class: 'icon-',
      unicode: 'e668',
      unicode_decimal: 58984,
    },
    {
      icon_id: '8362847',
      name: '无记录',
      font_class: 'wujilu',
      unicode: 'e615',
      unicode_decimal: 58901,
    },
    {
      icon_id: '2502536',
      name: '关闭',
      font_class: 'tishi',
      unicode: 'e607',
      unicode_decimal: 58887,
    },
    {
      icon_id: '7597997',
      name: '向下',
      font_class: 'arrowDown3',
      unicode: 'eb77',
      unicode_decimal: 60279,
    },
    {
      icon_id: '15252811',
      name: '日常维保',
      font_class: 'weibaojichushezhi',
      unicode: 'e6fb',
      unicode_decimal: 59131,
    },
    {
      icon_id: '39035093',
      name: '故障维修',
      font_class: 'weibaodengji',
      unicode: 'e770',
      unicode_decimal: 59248,
    },
    {
      icon_id: '34701397',
      name: '室外',
      font_class: 'a-shiwai_huaban1',
      unicode: 'e700',
      unicode_decimal: 59136,
    },
    {
      icon_id: '35975885',
      name: '室内',
      font_class: 'wodefangjian',
      unicode: 'e6f7',
      unicode_decimal: 59127,
    },
    {
      icon_id: '17567206',
      name: '督查督办',
      font_class: 'wodeduban',
      unicode: 'e6eb',
      unicode_decimal: 59115,
    },
    {
      icon_id: '40200502',
      name: '待检工单',
      font_class: 'daijiangongdan',
      unicode: 'e814',
      unicode_decimal: 59412,
    },
    {
      icon_id: '40200353',
      name: '隐患工单',
      font_class: 'yinhuanpaicha1-copy',
      unicode: '100dd',
      unicode_decimal: 65757,
    },
    {
      icon_id: '12616682',
      name: '维修工单',
      font_class: 'gongdanweihu',
      unicode: 'e62b',
      unicode_decimal: 58923,
    },
    {
      icon_id: '1365521',
      name: '待处理',
      font_class: 'jihuadaichuli',
      unicode: 'e610',
      unicode_decimal: 58896,
    },
    {
      icon_id: '40193215',
      name: '九宫格',
      font_class: 'jiugongge1',
      unicode: 'e810',
      unicode_decimal: 59408,
    },
    {
      icon_id: '40193502',
      name: '一屏',
      font_class: 'yiping',
      unicode: 'e813',
      unicode_decimal: 59411,
    },
    {
      icon_id: '40193503',
      name: '十六宫格',
      font_class: 'shiliugongge',
      unicode: 'e811',
      unicode_decimal: 59409,
    },
    {
      icon_id: '40193504',
      name: '四宫格',
      font_class: 'sigongge',
      unicode: 'e812',
      unicode_decimal: 59410,
    },
    {
      icon_id: '10544914',
      name: '晴',
      font_class: 'qing',
      unicode: 'e923',
      unicode_decimal: 59683,
    },
    {
      icon_id: '10544915',
      name: '大雨',
      font_class: 'dayu',
      unicode: 'e935',
      unicode_decimal: 59701,
    },
    {
      icon_id: '418260',
      name: '绑定',
      font_class: 'bangdingshujuyuan',
      unicode: 'e65e',
      unicode_decimal: 58974,
    },
    {
      icon_id: '40044422',
      name: '收起',
      font_class: 'shouqizhankai-copy',
      unicode: 'e688a',
      unicode_decimal: 944266,
    },
    {
      icon_id: '38320430',
      name: '展开',
      font_class: 'shouqizhankai',
      unicode: 'e65f',
      unicode_decimal: 58975,
    },
    {
      icon_id: '577403',
      name: '向右2',
      font_class: 'xiangyou2',
      unicode: 'e776',
      unicode_decimal: 59254,
    },
    {
      icon_id: '577407',
      name: '向左2',
      font_class: 'xiangzuo2',
      unicode: 'e77a',
      unicode_decimal: 59258,
    },
    {
      icon_id: '34166799',
      name: '退出',
      font_class: 'tuichu4',
      unicode: 'e6c5',
      unicode_decimal: 59077,
    },
    {
      icon_id: '18640126',
      name: '保存 线性',
      font_class: 'Save',
      unicode: 'e658',
      unicode_decimal: 58968,
    },
    {
      icon_id: '23998499',
      name: '尺寸',
      font_class: 'chicun',
      unicode: 'e6b5',
      unicode_decimal: 59061,
    },
    {
      icon_id: '19317216',
      name: '模板',
      font_class: 'moban2',
      unicode: 'f07b',
      unicode_decimal: 61563,
    },
    {
      icon_id: '17755684',
      name: '颜色',
      font_class: 'yanse',
      unicode: 'e60e',
      unicode_decimal: 58894,
    },
    {
      icon_id: '588699',
      name: '撤销',
      font_class: 'chexiao',
      unicode: 'e6e9',
      unicode_decimal: 59113,
    },
    {
      icon_id: '588709',
      name: '恢复',
      font_class: 'fanchexiao',
      unicode: 'e6ed',
      unicode_decimal: 59117,
    },
    {
      icon_id: '8745413',
      name: '重置',
      font_class: 'zhongzhi1',
      unicode: 'e633',
      unicode_decimal: 58931,
    },
    {
      icon_id: '21976551',
      name: '选择',
      font_class: 'xuanze',
      unicode: 'e66b',
      unicode_decimal: 58987,
    },
    {
      icon_id: '18310621',
      name: '提示',
      font_class: 'tishi2',
      unicode: 'e628',
      unicode_decimal: 58920,
    },
    {
      icon_id: '12719937',
      name: '发送',
      font_class: 'fasong',
      unicode: 'e60d',
      unicode_decimal: 58893,
    },
    {
      icon_id: '9017020',
      name: '上报',
      font_class: 'shangbaofenzu',
      unicode: 'e654',
      unicode_decimal: 58964,
    },
    {
      icon_id: '2529373',
      name: '向左',
      font_class: 'xiangyou1',
      unicode: 'e6fa',
      unicode_decimal: 59130,
    },
    {
      icon_id: '7370494',
      name: '向左',
      font_class: 'xiangyou3',
      unicode: 'e6ff',
      unicode_decimal: 59135,
    },
    {
      icon_id: '38567231',
      name: '巡检',
      font_class: 'xunjian1',
      unicode: 'e6e0',
      unicode_decimal: 59104,
    },
    {
      icon_id: '32352226',
      name: '重点区域',
      font_class: 'zhongdianquyu2',
      unicode: 'e6dc',
      unicode_decimal: 59100,
    },
    {
      icon_id: '38876806',
      name: '摄像头-禁用',
      font_class: 'shexiangtou-jinyong',
      unicode: 'e882',
      unicode_decimal: 59522,
    },
    {
      icon_id: '1409832',
      name: '摄像头',
      font_class: 'shexiangtou4',
      unicode: 'e6bf',
      unicode_decimal: 59071,
    },
    {
      icon_id: '848634',
      name: '角标',
      font_class: 'jiaobiao1',
      unicode: 'e637',
      unicode_decimal: 58935,
    },
    {
      icon_id: '7594157',
      name: '播放',
      font_class: 'gf-playCircle',
      unicode: 'ea82',
      unicode_decimal: 60034,
    },
    {
      icon_id: '5259246',
      name: '关联信息',
      font_class: 'guanlianxinxi-copy',
      unicode: 'e600',
      unicode_decimal: 58880,
    },
    {
      icon_id: '19169931',
      name: '运行状态',
      font_class: 'yunhangzhuangtai',
      unicode: 'e616',
      unicode_decimal: 58902,
    },
    {
      icon_id: '11360909',
      name: '远程操作',
      font_class: 'yuanchengfuzhu',
      unicode: 'e617',
      unicode_decimal: 58903,
    },
    {
      icon_id: '13393249',
      name: '设备状态',
      font_class: 'shebeizhuangtai',
      unicode: 'e60c',
      unicode_decimal: 58892,
    },
    {
      icon_id: '18164621',
      name: '全流程质控',
      font_class: 'org',
      unicode: 'e865',
      unicode_decimal: 59493,
    },
    {
      icon_id: '8687349',
      name: '无数据',
      font_class: 'kong4',
      unicode: 'e60b',
      unicode_decimal: 58891,
    },
    {
      icon_id: '1766316',
      name: '上传',
      font_class: 'shangchuan1',
      unicode: 'e6889',
      unicode_decimal: 944265,
    },
    {
      icon_id: '1766327',
      name: '下载',
      font_class: 'xiazai11',
      unicode: 'e6bd',
      unicode_decimal: 59069,
    },
    {
      icon_id: '9768589',
      name: '表格',
      font_class: 'biaoge2',
      unicode: 'f24a',
      unicode_decimal: 62026,
    },
    {
      icon_id: '3590954',
      name: '处理',
      font_class: 'tixianchuli',
      unicode: 'e6af',
      unicode_decimal: 59055,
    },
    {
      icon_id: '18970911',
      name: '批量处理',
      font_class: 'piliangchuli',
      unicode: 'e6b0',
      unicode_decimal: 59056,
    },
    {
      icon_id: '23863259',
      name: '审核',
      font_class: 'shenhe',
      unicode: 'e62d',
      unicode_decimal: 58925,
    },
    {
      icon_id: '10172816',
      name: '二维码',
      font_class: 'qrcode',
      unicode: 'e657',
      unicode_decimal: 58967,
    },
    {
      icon_id: '9473635',
      name: '导入',
      font_class: 'daoru',
      unicode: 'ebe4',
      unicode_decimal: 60388,
    },
    {
      icon_id: '10734756',
      name: '导出',
      font_class: 'daochu',
      unicode: 'e6e4',
      unicode_decimal: 59108,
    },
    {
      icon_id: '11320729',
      name: '维修',
      font_class: 'weixiu1',
      unicode: 'e6d4',
      unicode_decimal: 59092,
    },
    {
      icon_id: '18468148',
      name: '已过期',
      font_class: 'yiguoqi1',
      unicode: 'e68c',
      unicode_decimal: 59020,
    },
    {
      icon_id: '19518754',
      name: '库存-报废',
      font_class: 'kucun-baofei',
      unicode: 'e676',
      unicode_decimal: 58998,
    },
    {
      icon_id: '23805331',
      name: '正常',
      font_class: 'zhengchang',
      unicode: 'e68a',
      unicode_decimal: 59018,
    },
    {
      icon_id: '33798578',
      name: '即将过期',
      font_class: 'a-lujing1',
      unicode: 'e684',
      unicode_decimal: 59012,
    },
    {
      icon_id: '39804050',
      name: '应急联动',
      font_class: 'yingjiliandong1',
      unicode: 'e96c',
      unicode_decimal: 59756,
    },
    {
      icon_id: '15410120',
      name: '特种作业管理',
      font_class: 'xuanzhongdefuben2',
      unicode: 'e966',
      unicode_decimal: 59750,
    },
    {
      icon_id: '12424267',
      name: '智慧单兵',
      font_class: 'icon_danbing',
      unicode: 'e945',
      unicode_decimal: 59717,
    },
    {
      icon_id: '18277460',
      name: '指挥调度',
      font_class: 'zhihuitiaodu-didian',
      unicode: 'e94b',
      unicode_decimal: 59723,
    },
    {
      icon_id: '39803425',
      name: '消防大数据结合展示',
      font_class: 'xiaofangdashujujiehezhanshi',
      unicode: 'e962',
      unicode_decimal: 59746,
    },
    {
      icon_id: '36674714',
      name: '图表分析',
      font_class: 'shujukanban',
      unicode: 'e941',
      unicode_decimal: 59713,
    },
    {
      icon_id: '1969476',
      name: '统计报告',
      font_class: 'ribaotongji',
      unicode: 'e875',
      unicode_decimal: 59509,
    },
    {
      icon_id: '5839249',
      name: '现场管理',
      font_class: 'diyutongji',
      unicode: 'e933',
      unicode_decimal: 59699,
    },
    {
      icon_id: '8265635',
      name: '预案模拟',
      font_class: 'lianxi',
      unicode: 'e924',
      unicode_decimal: 59684,
    },
    {
      icon_id: '26992375',
      name: '指挥调度',
      font_class: 'yunyingzhihuitiaodu',
      unicode: 'e92d',
      unicode_decimal: 59693,
    },
    {
      icon_id: '15346356',
      name: '图上作战标绘工具',
      font_class: 'pencel',
      unicode: 'e927',
      unicode_decimal: 59687,
    },
    {
      icon_id: '34925904',
      name: '设备状态',
      font_class: 'shebeizhuangtai3',
      unicode: 'e903',
      unicode_decimal: 59651,
    },
    {
      icon_id: '2900090',
      name: '通知列表',
      font_class: 'tongzhiliebiao',
      unicode: 'e8f1',
      unicode_decimal: 59633,
    },
    {
      icon_id: '37005210',
      name: '视频',
      font_class: 'shipin2',
      unicode: 'e8fc',
      unicode_decimal: 59644,
    },
    {
      icon_id: '16972441',
      name: '群组通话',
      font_class: 'tonghuajilup',
      unicode: 'e8e9',
      unicode_decimal: 59625,
    },
    {
      icon_id: '19364012',
      name: '视频回放',
      font_class: 'shipinhuifang2',
      unicode: 'e8e3',
      unicode_decimal: 59619,
    },
    {
      icon_id: '38922625',
      name: '救援力量管理',
      font_class: 'qingzhangjiuyuanguanli',
      unicode: 'e8c5',
      unicode_decimal: 59589,
    },
    {
      icon_id: '1390108',
      name: '应急预案',
      font_class: 'yingjiyuan1',
      unicode: 'e8c8',
      unicode_decimal: 59592,
    },
    {
      icon_id: '34057825',
      name: '应急联动管理',
      font_class: 'liandong-normal',
      unicode: 'e8dd',
      unicode_decimal: 59613,
    },
    {
      icon_id: '26297852',
      name: '培训管理',
      font_class: 'peixunguanli1',
      unicode: 'e8df',
      unicode_decimal: 59615,
    },
    {
      icon_id: '26321676',
      name: '培训演练',
      font_class: 'yingjiyanlian1',
      unicode: 'e8e0',
      unicode_decimal: 59616,
    },
    {
      icon_id: '32281150',
      name: '评估依据',
      font_class: 'huodongjilu',
      unicode: 'e81b',
      unicode_decimal: 59419,
    },
    {
      icon_id: '31402557',
      name: '规范资源',
      font_class: 'wendangzhongxin-guifanzhidu',
      unicode: 'e8ac',
      unicode_decimal: 59564,
    },
    {
      icon_id: '15417426',
      name: '项目管理',
      font_class: 'base_itemxiangmuguanli',
      unicode: 'e8a1',
      unicode_decimal: 59553,
    },
    {
      icon_id: '25577956',
      name: '危险气体',
      font_class: 'weixianqiti',
      unicode: 'eca4',
      unicode_decimal: 60580,
    },
    {
      icon_id: '39796262',
      name: '喷淋灭火系统',
      font_class: 'a-penlinmiehuoxitong_huaban1',
      unicode: 'e899',
      unicode_decimal: 59545,
    },
    {
      icon_id: '15659292',
      name: '气体灭火',
      font_class: 'miehuoqi3',
      unicode: 'e7fb',
      unicode_decimal: 59387,
    },
    {
      icon_id: '14487166',
      name: '声光报警系统',
      font_class: 'shengguang',
      unicode: 'e883',
      unicode_decimal: 59523,
    },
    {
      icon_id: '23805828',
      name: '防火分割措施',
      font_class: 'nengyuanguanliku-179caidantubiao-fanghuomen',
      unicode: 'e889',
      unicode_decimal: 59529,
    },
    {
      icon_id: '4944404',
      name: '消防栓',
      font_class: 'zuoce-geipaishuiyuxiaofang',
      unicode: 'e837',
      unicode_decimal: 59447,
    },
    {
      icon_id: '26548147',
      name: '漏水',
      font_class: 'loushui2',
      unicode: 'e87f',
      unicode_decimal: 59519,
    },
    {
      icon_id: '16986282',
      name: '微型消防站',
      font_class: 'weixingxiaofangzhan',
      unicode: 'e86e',
      unicode_decimal: 59502,
    },
    {
      icon_id: '7730655',
      name: '消防电源监测',
      font_class: 'dianyuan',
      unicode: 'e87a',
      unicode_decimal: 59514,
    },
    {
      icon_id: '4585517',
      name: '防烟排烟系统',
      font_class: 'jixiefangyanpaiyanxitong',
      unicode: 'e862',
      unicode_decimal: 59490,
    },
    {
      icon_id: '15062355',
      name: '智能无线烟感',
      font_class: 'Clip2',
      unicode: 'e859',
      unicode_decimal: 59481,
    },
    {
      icon_id: '11888519',
      name: '电气火灾',
      font_class: 'dianqihuozai2',
      unicode: 'e866',
      unicode_decimal: 59494,
    },
    {
      icon_id: '10076798',
      name: '特种作业管理',
      font_class: 'xiaofang',
      unicode: 'e84b',
      unicode_decimal: 59467,
    },
    {
      icon_id: '1638823',
      name: '监视督查信息',
      font_class: 'SQLshenhe',
      unicode: 'e831',
      unicode_decimal: 59441,
    },
    {
      icon_id: '729418',
      name: '积分管理',
      font_class: 'wodejifen',
      unicode: 'e827',
      unicode_decimal: 59431,
    },
    {
      icon_id: '24080627',
      name: '值班查岗',
      font_class: 'paiban',
      unicode: 'e820',
      unicode_decimal: 59424,
    },
    {
      icon_id: '8868302',
      name: '日志审计管理',
      font_class: 'paibanzhibanci',
      unicode: 'e81f',
      unicode_decimal: 59423,
    },
    {
      icon_id: '3201942',
      name: '工单记录',
      font_class: 'gongdanguanli',
      unicode: 'e800',
      unicode_decimal: 59392,
    },
    {
      icon_id: '11477697',
      name: '工单管理',
      font_class: 'weixiudan',
      unicode: 'e815',
      unicode_decimal: 59413,
    },
    {
      icon_id: '9006175',
      name: '设备管理',
      font_class: 'shebeiguanli3',
      unicode: 'e7ef',
      unicode_decimal: 59375,
    },
    {
      icon_id: '35969094',
      name: '服务单位',
      font_class: 'weibaotixing',
      unicode: 'e7e9',
      unicode_decimal: 59369,
    },
    {
      icon_id: '8984178',
      name: '消息推送',
      font_class: 'xiaoxituisong',
      unicode: 'e7d8',
      unicode_decimal: 59352,
    },
    {
      icon_id: '6571516',
      name: '报警数据',
      font_class: 'baojingpeizhi',
      unicode: 'e7d1',
      unicode_decimal: 59345,
    },
    {
      icon_id: '12891154',
      name: '配置',
      font_class: 'xitongweihu',
      unicode: 'e71b',
      unicode_decimal: 59163,
    },
    {
      icon_id: '12324398',
      name: '文件管理',
      font_class: 'wenjianguanli11',
      unicode: 'e7c5',
      unicode_decimal: 59333,
    },
    {
      icon_id: '2604738',
      name: '版本',
      font_class: 'banben',
      unicode: 'e989',
      unicode_decimal: 59785,
    },
    {
      icon_id: '10600640',
      name: '消息',
      font_class: 'weibiaoti-1',
      unicode: 'e7bc',
      unicode_decimal: 59324,
    },
    {
      icon_id: '9430033',
      name: '租户管理',
      font_class: 'zuhuguanli',
      unicode: 'e7d5',
      unicode_decimal: 59349,
    },
    {
      icon_id: '3176473',
      name: '参数管理',
      font_class: 'danpaipailie',
      unicode: 'e73e',
      unicode_decimal: 59198,
    },
    {
      icon_id: '1359164',
      name: '菜单管理',
      font_class: 'liebiao',
      unicode: 'e795',
      unicode_decimal: 59285,
    },
    {
      icon_id: '2043536',
      name: '角色管理',
      font_class: 'yonghuguanli',
      unicode: 'e780',
      unicode_decimal: 59264,
    },
    {
      icon_id: '5699215',
      name: '用户管理',
      font_class: 'UI_yonghuguanli',
      unicode: 'e850',
      unicode_decimal: 59472,
    },
    {
      icon_id: '26301850',
      name: '共享',
      font_class: 'a-ziyuan89',
      unicode: 'e774',
      unicode_decimal: 59252,
    },
    {
      icon_id: '10080138',
      name: '数据局接口',
      font_class: 'jiekoupeizhi',
      unicode: 'e76c',
      unicode_decimal: 59244,
    },
    {
      icon_id: '12733264',
      name: '数据资产',
      font_class: 'shujuzichan',
      unicode: 'e768',
      unicode_decimal: 59240,
    },
    {
      icon_id: '11661818',
      name: '数据上传统计',
      font_class: 'bendijieyuetongji',
      unicode: 'e767',
      unicode_decimal: 59239,
    },
    {
      icon_id: '39450945',
      name: '资源中心',
      font_class: 'ziyuanzhongxin2',
      unicode: 'e763',
      unicode_decimal: 59235,
    },
    {
      icon_id: '10424098',
      name: '主索引注册管理',
      font_class: 'zhuce',
      unicode: 'e74a',
      unicode_decimal: 59210,
    },
    {
      icon_id: '11121513',
      name: '主索引规则管理',
      font_class: 'youxuliebiao',
      unicode: 'e745',
      unicode_decimal: 59205,
    },
    {
      icon_id: '39786122',
      name: '服务监控',
      font_class: 'icon_fuwujiankong',
      unicode: 'e7fc',
      unicode_decimal: 59388,
    },
    {
      icon_id: '9458092',
      name: '数据质量监管',
      font_class: 'shujuzhiliang-',
      unicode: 'e732',
      unicode_decimal: 59186,
    },
    {
      icon_id: '15363511',
      name: '数据交换监控',
      font_class: 'shujujiaohuanweixuanzhong',
      unicode: 'e71f',
      unicode_decimal: 59167,
    },
    {
      icon_id: '26020910',
      name: '评分配置',
      font_class: 'pingfen2',
      unicode: 'e731',
      unicode_decimal: 59185,
    },
    {
      icon_id: '11910286',
      name: '质控规则配置',
      font_class: 'zhikongguanli',
      unicode: 'e712',
      unicode_decimal: 59154,
    },
    {
      icon_id: '33095718',
      name: '机构质控配置',
      font_class: 'jigou1',
      unicode: '100f1',
      unicode_decimal: 65777,
    },
    {
      icon_id: '39782609',
      name: '数据质量总览',
      font_class: 'zhuye03-L-copy',
      unicode: 'ed1b',
      unicode_decimal: 60699,
    },
    {
      icon_id: '39780206',
      name: '数据异常管理',
      font_class: 'yichangguanli5-copy',
      unicode: 'ed1a',
      unicode_decimal: 60698,
    },
    {
      icon_id: '32566330',
      name: '数据探查',
      font_class: 'shujutancha1',
      unicode: 'e7b2',
      unicode_decimal: 59314,
    },
    {
      icon_id: '33632593',
      name: '元数据管理',
      font_class: 'yuanshujuguanli2',
      unicode: 'e6ea',
      unicode_decimal: 59114,
    },
    {
      icon_id: '29249894',
      name: '数据标准化',
      font_class: 'shujuku5',
      unicode: 'e6d3',
      unicode_decimal: 59091,
    },
    {
      icon_id: '577357',
      name: '删除',
      font_class: 'shanchu',
      unicode: 'e74b',
      unicode_decimal: 59211,
    },
    {
      icon_id: '11362481',
      name: '查看 (3)',
      font_class: 'chakan1',
      unicode: 'e78f',
      unicode_decimal: 59279,
    },
    {
      icon_id: '10138957',
      name: '数据量比对',
      font_class: 'hechabidui',
      unicode: 'e6c7',
      unicode_decimal: 59079,
    },
    {
      icon_id: '28834508',
      name: '采集节点监控',
      font_class: 'shujujiankong2',
      unicode: 'e6bc',
      unicode_decimal: 59068,
    },
    {
      icon_id: '16136940',
      name: '日志管理',
      font_class: 'rili2',
      unicode: 'e6ae',
      unicode_decimal: 59054,
    },
    {
      icon_id: '9188971',
      name: '采集任务模板',
      font_class: 'mobanguanli1',
      unicode: 'e6a6',
      unicode_decimal: 59046,
    },
    {
      icon_id: '6700812',
      name: '采集任务构建',
      font_class: 'weixiubanshou1',
      unicode: 'e692',
      unicode_decimal: 59026,
    },
    {
      icon_id: '6696519',
      name: '配置',
      font_class: 'jiedianguanli3',
      unicode: 'e68b',
      unicode_decimal: 59019,
    },
    {
      icon_id: '14553749',
      name: '采集节点配置',
      font_class: 'jiedian3',
      unicode: 'e686',
      unicode_decimal: 59014,
    },
    {
      icon_id: '21640689',
      name: '数据源管理',
      font_class: 'biaoge5',
      unicode: 'e766',
      unicode_decimal: 59238,
    },
    {
      icon_id: '24992931',
      name: '指派',
      font_class: 'zhipai',
      unicode: 'e69a',
      unicode_decimal: 59034,
    },
    {
      icon_id: '4933446',
      name: '设备实时数据',
      font_class: 'zhexiantu',
      unicode: 'e7ba',
      unicode_decimal: 59322,
    },
    {
      icon_id: '2552662',
      name: '公共-日期 ',
      font_class: 'riqi1',
      unicode: 'e7a6',
      unicode_decimal: 59302,
    },
    {
      icon_id: '11391529',
      name: '位置',
      font_class: 'weizhi',
      unicode: 'e638',
      unicode_decimal: 58936,
    },
    {
      icon_id: '37540742',
      name: '建筑',
      font_class: 'jianzhu02-L',
      unicode: 'e630',
      unicode_decimal: 58928,
    },
    {
      icon_id: '4718655',
      name: '编号',
      font_class: 'qishibianhao',
      unicode: 'e627',
      unicode_decimal: 58919,
    },
    {
      icon_id: '1305451',
      name: '标签',
      font_class: 'biaoqian',
      unicode: 'e63d',
      unicode_decimal: 58941,
    },
    {
      icon_id: '12101314',
      name: '已完成',
      font_class: 'yiwancheng1',
      unicode: 'e61a',
      unicode_decimal: 58906,
    },
    {
      icon_id: '25853324',
      name: '链接',
      font_class: 'lianjie',
      unicode: 'e6e7',
      unicode_decimal: 59111,
    },
    {
      icon_id: '25853327',
      name: '链接断开',
      font_class: 'lianjieduankai',
      unicode: 'e6e8',
      unicode_decimal: 59112,
    },
    {
      icon_id: '7588127',
      name: '右',
      font_class: 'you',
      unicode: 'e625',
      unicode_decimal: 58917,
    },
    {
      icon_id: '7588133',
      name: '左',
      font_class: 'zuo',
      unicode: 'e626',
      unicode_decimal: 58918,
    },
    {
      icon_id: '7556878',
      name: '减少',
      font_class: 'jianshao',
      unicode: 'e60f',
      unicode_decimal: 58895,
    },
    {
      icon_id: '2966906',
      name: '操作-播放-暂停',
      font_class: 'caozuo-bofang-zanting',
      unicode: 'e6fe',
      unicode_decimal: 59134,
    },
    {
      icon_id: '4777227',
      name: '缩小',
      font_class: 'suoxiao',
      unicode: 'ec13',
      unicode_decimal: 60435,
    },
    {
      icon_id: '4777229',
      name: '放大',
      font_class: 'fangda',
      unicode: 'ec14',
      unicode_decimal: 60436,
    },
    {
      icon_id: '6909426',
      name: '模板',
      font_class: 'zhunbeiliangchan',
      unicode: 'ecaa',
      unicode_decimal: 60586,
    },
    {
      icon_id: '7140118',
      name: '组件',
      font_class: 'zujian',
      unicode: 'e65b',
      unicode_decimal: 58971,
    },
    {
      icon_id: '7947379',
      name: '空心问号',
      font_class: 'kongxinwenhao',
      unicode: 'ed19',
      unicode_decimal: 60697,
    },
    {
      icon_id: '8288831',
      name: '地球',
      font_class: 'diqiu',
      unicode: 'e844',
      unicode_decimal: 59460,
    },
    {
      icon_id: '10219732',
      name: '设备_地球仪02',
      font_class: 'shebei_diqiuyi',
      unicode: 'e9b8',
      unicode_decimal: 59832,
    },
    {
      icon_id: '24271933',
      name: '视频监视-播放按钮',
      font_class: 'shipinjianshi-bofanganniu',
      unicode: 'e672',
      unicode_decimal: 58994,
    },
    {
      icon_id: '8389103',
      name: '下级',
      font_class: 'xiaji1',
      unicode: 'e6a5',
      unicode_decimal: 59045,
    },
    {
      icon_id: '8802647',
      name: '定位',
      font_class: 'dingwei1',
      unicode: 'e64d',
      unicode_decimal: 58957,
    },
    {
      icon_id: '20985465',
      name: '报警',
      font_class: 'gaoweiyujing',
      unicode: 'e75a',
      unicode_decimal: 59226,
    },
    {
      icon_id: '31226750',
      name: '摄像头',
      font_class: 'shexiangtou10',
      unicode: 'e6f0',
      unicode_decimal: 59120,
    },
    {
      icon_id: '1287695',
      name: '设置',
      font_class: 'shezhi',
      unicode: 'e792',
      unicode_decimal: 59282,
    },
    {
      icon_id: '17971524',
      name: '消 息',
      font_class: 'xiaoxi1',
      unicode: 'e6d6',
      unicode_decimal: 59094,
    },
    {
      icon_id: '4933365',
      name: '皮肤',
      font_class: 'pifu',
      unicode: 'e743',
      unicode_decimal: 59203,
    },
    {
      icon_id: '2477505',
      name: '防火门',
      font_class: 'fanghuomen',
      unicode: 'e73a',
      unicode_decimal: 59194,
    },
    {
      icon_id: '5041653',
      name: '可燃气体',
      font_class: 'jianzhuanquan-',
      unicode: 'e753',
      unicode_decimal: 59219,
    },
    {
      icon_id: '8704283',
      name: '电气火灾监测',
      font_class: 'huaban',
      unicode: 'e72c',
      unicode_decimal: 59180,
    },
    {
      icon_id: '17891280',
      name: '设备',
      font_class: 'shebeifenlei-gangpingwangguan-01',
      unicode: 'e75c',
      unicode_decimal: 59228,
    },
    {
      icon_id: '31485969',
      name: '消防用水',
      font_class: 'xiaofangyongshui',
      unicode: 'e765',
      unicode_decimal: 59237,
    },
    {
      icon_id: '39633209',
      name: '无线感烟',
      font_class: 'wuxianganyan',
      unicode: 'e7f7',
      unicode_decimal: 59383,
    },
    {
      icon_id: '39649834',
      name: '今天',
      font_class: 'jintian',
      unicode: 'e7f9',
      unicode_decimal: 59385,
    },
    {
      icon_id: '39649835',
      name: '一月',
      font_class: 'yiyue2',
      unicode: 'e7f8',
      unicode_decimal: 59384,
    },
    {
      icon_id: '39649836',
      name: '一周',
      font_class: 'yizhou1',
      unicode: 'e7fa',
      unicode_decimal: 59386,
    },
    {
      icon_id: '2477513',
      name: '通用资产',
      font_class: 'tongyongzichan',
      unicode: 'e744',
      unicode_decimal: 59204,
    },
    {
      icon_id: '8662287',
      name: '故障',
      font_class: 'guzhang',
      unicode: 'e778',
      unicode_decimal: 59256,
    },
    {
      icon_id: '10726054',
      name: '设备离线',
      font_class: 'shebeilixian',
      unicode: 'e77b',
      unicode_decimal: 59259,
    },
    {
      icon_id: '37544462',
      name: 'swfzjc-报警',
      font_class: 'a-baojingjingbaobaojingdengweixian',
      unicode: 'e78c',
      unicode_decimal: 59276,
    },
    {
      icon_id: '4893191',
      name: '文件夹',
      font_class: 'wenjianjia',
      unicode: 'ec17',
      unicode_decimal: 60439,
    },
    {
      icon_id: '39573620',
      name: '综合展示',
      font_class: 'zonghezhanshi',
      unicode: 'e7f6',
      unicode_decimal: 59382,
    },
    {
      icon_id: '39573543',
      name: '态势分析',
      font_class: 'taishifenxi',
      unicode: 'e7f5',
      unicode_decimal: 59381,
    },
    {
      icon_id: '39573534',
      name: '统计分析',
      font_class: 'tongjifenxi',
      unicode: 'e7f4',
      unicode_decimal: 59380,
    },
    {
      icon_id: '39573495',
      name: '培训演练',
      font_class: 'peixunyanlian',
      unicode: 'e7f3',
      unicode_decimal: 59379,
    },
    {
      icon_id: '39573490',
      name: '应急预案',
      font_class: 'yingjiyuan',
      unicode: 'e7f2',
      unicode_decimal: 59378,
    },
    {
      icon_id: '39573447',
      name: '风险评估',
      font_class: 'fengxianpinggu',
      unicode: 'e7f1',
      unicode_decimal: 59377,
    },
    {
      icon_id: '39573389',
      name: '智慧安防',
      font_class: 'zhihuianfang1',
      unicode: 'e7f0',
      unicode_decimal: 59376,
    },
    {
      icon_id: '39573276',
      name: '智慧消防',
      font_class: 'zhihuixiaofang',
      unicode: 'e7ee',
      unicode_decimal: 59374,
    },
    {
      icon_id: '39564942',
      name: '数据采集',
      font_class: 'shujucaiji',
      unicode: 'e7df',
      unicode_decimal: 59359,
    },
    {
      icon_id: '39565904',
      name: '数据治理',
      font_class: 'shujuzhili',
      unicode: 'e7e0',
      unicode_decimal: 59360,
    },
    {
      icon_id: '39566356',
      name: '数据监控',
      font_class: 'shujujiankong',
      unicode: 'e7e1',
      unicode_decimal: 59361,
    },
    {
      icon_id: '39566607',
      name: '数据整合',
      font_class: 'shujuzhenghe',
      unicode: 'e7e2',
      unicode_decimal: 59362,
    },
    {
      icon_id: '39567177',
      name: '服务总线',
      font_class: 'fuwuzongxian',
      unicode: 'e7e3',
      unicode_decimal: 59363,
    },
    {
      icon_id: '39567482',
      name: '数据存储',
      font_class: 'shujucunchu',
      unicode: 'e7e4',
      unicode_decimal: 59364,
    },
    {
      icon_id: '39568140',
      name: '数据服务',
      font_class: 'shujufuwu',
      unicode: 'e7e5',
      unicode_decimal: 59365,
    },
    {
      icon_id: '39568314',
      name: '数据安全',
      font_class: 'shujuanquan',
      unicode: 'e7e6',
      unicode_decimal: 59366,
    },
    {
      icon_id: '39568591',
      name: '平台管理',
      font_class: 'pingtaiguanli',
      unicode: 'e7e7',
      unicode_decimal: 59367,
    },
    {
      icon_id: '39571019',
      name: '告警管理',
      font_class: 'gaojingguanli',
      unicode: 'e7e8',
      unicode_decimal: 59368,
    },
    {
      icon_id: '39571728',
      name: '单位管理',
      font_class: 'danweiguanli1',
      unicode: 'e7ea',
      unicode_decimal: 59370,
    },
    {
      icon_id: '39572344',
      name: '资产管理',
      font_class: 'zichanguanli',
      unicode: 'e7eb',
      unicode_decimal: 59371,
    },
    {
      icon_id: '39572546',
      name: '智慧巡检',
      font_class: 'zhihuixunjian',
      unicode: 'e7ec',
      unicode_decimal: 59372,
    },
    {
      icon_id: '39572775',
      name: 'OA办公',
      font_class: 'OAbangong4',
      unicode: 'e7ed',
      unicode_decimal: 59373,
    },
    {
      icon_id: '6539442',
      name: '文件',
      font_class: 'wenjian',
      unicode: 'e6a3',
      unicode_decimal: 59043,
    },
    {
      icon_id: '13113661',
      name: '新增',
      font_class: 'xinzeng',
      unicode: 'e6ac',
      unicode_decimal: 59052,
    },
    {
      icon_id: '16206718',
      name: '文件',
      font_class: 'wenjian2',
      unicode: 'e6ad',
      unicode_decimal: 59053,
    },
    {
      icon_id: '9592591',
      name: '刷新',
      font_class: 'shuaxin3',
      unicode: 'e6a4',
      unicode_decimal: 59044,
    },
    {
      icon_id: '8224810',
      name: '展开',
      font_class: 'zhankai',
      unicode: 'e602',
      unicode_decimal: 58882,
    },
    {
      icon_id: '8224841',
      name: '收缩',
      font_class: 'shousuo',
      unicode: 'e60a',
      unicode_decimal: 58890,
    },
    {
      icon_id: '1526325',
      name: '加号1',
      font_class: 'jiahao2',
      unicode: 'e69b',
      unicode_decimal: 59035,
    },
    {
      icon_id: '1526327',
      name: '减号',
      font_class: 'jianhao2',
      unicode: 'e69d',
      unicode_decimal: 59037,
    },
    {
      icon_id: '37540745',
      name: '建筑03-L',
      font_class: 'jianzhu03-L',
      unicode: 'e699',
      unicode_decimal: 59033,
    },
    {
      icon_id: '1435243',
      name: '首页',
      font_class: 'shouye1',
      unicode: 'e682',
      unicode_decimal: 59010,
    },
    {
      icon_id: '24550452',
      name: '全屏',
      font_class: 'line-062',
      unicode: 'e740',
      unicode_decimal: 59200,
    },
    {
      icon_id: '24550453',
      name: '退出全屏',
      font_class: 'line-063',
      unicode: 'e741',
      unicode_decimal: 59201,
    },
    {
      icon_id: '17118085',
      name: '编辑',
      font_class: 'xiugai',
      unicode: 'e6cd',
      unicode_decimal: 59085,
    },
    {
      icon_id: '19518073',
      name: '向下',
      font_class: 'arrow-top',
      unicode: 'e614',
      unicode_decimal: 58900,
    },
    {
      icon_id: '19725053',
      name: '向上',
      font_class: 'up',
      unicode: 'e87b',
      unicode_decimal: 59515,
    },
    {
      icon_id: '24715130',
      name: '5_柱形图3',
      font_class: 'a-5_zhuxingtu3',
      unicode: 'e6c6',
      unicode_decimal: 59078,
    },
    {
      icon_id: '4143524',
      name: '返回',
      font_class: 'fanhui3',
      unicode: 'e65a',
      unicode_decimal: 58970,
    },
    {
      icon_id: '6400267',
      name: '开关',
      font_class: 'weibiaoti--',
      unicode: 'e62c',
      unicode_decimal: 58924,
    },
    {
      icon_id: '1304895',
      name: '用户-圆',
      font_class: 'yonghu-yuan',
      unicode: 'e623',
      unicode_decimal: 58915,
    },
    {
      icon_id: '1440921',
      name: '下载',
      font_class: 'xiazai',
      unicode: 'e643',
      unicode_decimal: 58947,
    },
    {
      icon_id: '1435252',
      name: '个人中心-我的',
      font_class: 'yonghu1',
      unicode: 'e63a',
      unicode_decimal: 58938,
    },
    {
      icon_id: '5022863',
      name: '验证码',
      font_class: 'yanzhengma1',
      unicode: 'e636',
      unicode_decimal: 58934,
    },
    {
      icon_id: '16398955',
      name: '显示',
      font_class: 'chakan',
      unicode: 'e853',
      unicode_decimal: 59475,
    },
    {
      icon_id: '16399027',
      name: '隐藏',
      font_class: 'yincang3',
      unicode: 'e860',
      unicode_decimal: 59488,
    },
    {
      icon_id: '32243108',
      name: '密码',
      font_class: 'mima1',
      unicode: 'e697',
      unicode_decimal: 59031,
    },
  ],
};
